import { getWechatPublicConfig } from "@/api/index";

/** 微信公众号登录 */
export async function loginWechat({
  redirectRoute,
}: { redirectRoute?: string } = {}) {
  const config = await getWechatPublicConfig()
  const appid = config?.appid
  let redirectUri = window.location.origin + `/pagesMp/login/index`
  // 跳转之前
  if (redirectRoute) {
    redirectUri += `?redirect_route=${redirectRoute}`;
  }
  redirectUri = encodeURIComponent(redirectUri)
  const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
  window.location.href = authUrl;
}
